import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import {
  Building2,
  FileText,
  Lightbulb,
  ShieldCheck,
  UserCheck,
} from 'lucide-react';

const services = [
  {
    icon: Building2,
    title: 'Abertura de Empresa',
    desc: 'CNPJ rápido, sem complicação e no enquadramento tributário correto. Grátis no plano anual de 12 meses — você paga apenas as taxas oficiais.',
    span: 'md:col-span-2',
  },
  {
    icon: FileText,
    title: 'Imposto de Renda PJ',
    desc: 'Declarações precisas para manter sua empresa 100% regular.',
    span: '',
  },
  {
    icon: Lightbulb,
    title: 'Consultoria Empresarial',
    desc: 'Orientação estratégica para tomada de decisões financeiras e tributárias.',
    span: '',
  },
  {
    icon: ShieldCheck,
    title: 'Simples Nacional',
    desc: 'Gestão completa do regime tributário mais utilizado por pequenas empresas no Brasil.',
    span: 'md:col-span-2',
  },
  {
    icon: UserCheck,
    title: 'Gestão de MEI',
    desc: 'Declaração anual, DAS mensal e desenquadramento quando necessário.',
    span: '',
  },
];

export default function Services() {
  const sectionRef = useScrollAnimation();

  return (
    <section
      id="servicos"
      data-testid="services-section"
      ref={sectionRef}
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Header */}
        <div className="scroll-fade mb-16 md:mb-20">
          <p className="text-sm uppercase tracking-[0.2em] font-semibold text-[#10B981] mb-4">
            Nossos Serviços
          </p>
          <h2
            className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#0A2540] tracking-tight leading-tight max-w-xl"
            style={{ fontFamily: "'Inter', sans-serif", letterSpacing: '-1px' }}
          >
            Soluções Completas para sua Empresa
          </h2>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 stagger-children">
          {services.map((item) => (
            <div
              key={item.title}
              data-testid={`service-card-${item.title.toLowerCase().replace(/\s/g, '-')}`}
              className={`scroll-fade service-card bg-[#F8FAFC] p-8 md:p-10 border border-slate-200 rounded-xl hover:-translate-y-1 transition-all duration-300 ${item.span}`}
            >
              <div className="flex items-start gap-5">
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center text-[#10B981]">
                  <item.icon size={28} strokeWidth={1.5} />
                </div>
                <div>
                  <h3
                    className="text-lg sm:text-xl font-bold text-[#0A2540] mb-2"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    {item.title}
                  </h3>
                  <p className="text-slate-600 text-sm sm:text-base leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
